import AccordionSection from "@common/components/thirdParty/mantine/accordion/AccordionSection";
import { ReactElement } from "react";
import { Anchor, Text } from "@mantine/core";
import IconInfo from "@common/components/icons/IconInfo";
import TitleWithIcon from "@common/components/thirdParty/mantine/text/TitleWithIcon";

export default function ContactSubscriptionSection(): ReactElement {
  return (
    <AccordionSection>
      <TitleWithIcon
        icon={<IconInfo size={13} />}
        title={
          <Text fz="sm" fw={700}>
            Anything you need? Please contact{" "}
            <Anchor href="mailto:sales@metabase.com">sales</Anchor>
          </Text>
        }
        order={3}
        size="h6"
      />
    </AccordionSection>
  );
}
